import { getMe } from "@elation/api-client/src/stitch-web";
import { navigation } from "@src/navigation";
import { useOktaAuthInstance } from "@src/okta/auth";
import { LoginCallbackPage } from "@src/pages/LoginCallback";
import { trackUserLoggedIn } from "@src/utils/observability/trackUserLoggedIn";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function meta() {
  return [
    { title: "Signing In..." },
    { name: "description", content: "Completing authentication" },
  ];
}

/**
 * Login callback route. Uses the SDK's handleLoginRedirect() to exchange the
 * auth code for tokens, store them, then navigate via restoreOriginalUri.
 * Do not call API or getAccessToken before this completes or tokens will be null.
 */
export default function LoginCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const oktaAuth = useOktaAuthInstance();
  const [isProcessing, setIsProcessing] = useState(true);

  const error = searchParams.get("error");
  const errorDescription = searchParams.get("error_description");
  const redirectTo = searchParams.get("redirectTo") || navigation.patients();

  useEffect(() => {
    if (error) {
      setIsProcessing(false);
      return;
    }

    const handleCallback = async () => {
      try {
        await oktaAuth.handleLoginRedirect();
        const { data: me } = await getMe();
        trackUserLoggedIn(me, "okta_web");
        navigate(redirectTo, { replace: true });
      } catch (err) {
        console.error("Error handling login redirect:", err);
        setIsProcessing(false);
      }
    };

    handleCallback();
  }, [error, redirectTo, navigate, oktaAuth]);

  const handleRetry = () => {
    navigate(navigation.login(), { replace: true });
  };

  return (
    <LoginCallbackPage
      error={error || undefined}
      errorDescription={errorDescription || undefined}
      isLoading={isProcessing}
      onRetry={handleRetry}
    />
  );
}
